module.exports = __webpack_public_path__ + "img/subject-face.1e273bf2.png";